import { getOrganisations } from "@/lib/Auth/authApi";

/**
 * Shared options for the `organisations` auth query so the cache key + fetcher
 * live in one place. Used by AuthProvider (the live subscription) and by route
 * loaders that need to resolve org membership (e.g. admin-org gating) without
 * waiting on a React render.
 */
export function organisationsQueryOptions(token: string | null) {
  return {
    queryKey: ["auth", "organisations"] as const,
    queryFn: async () => {
      if (!token) return null;
      try {
        return await getOrganisations(token);
      } catch {
        return null;
      }
    },
    staleTime: 5 * 60 * 1000,
  };
}
